module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_6005.fd61720b.png";